// extracted by mini-css-extract-plugin
export default {"radio":"styles_radio__9D2J8","selected":"styles_selected__nUlpY","tag":"styles_tag__RgVRv"};